const topics = [
  { tag: '古装剧回归', heat: '98.6万', trend: 'up', desc: '今年古装大制作扎堆上线' },
  { tag: '悬疑烧脑', heat: '87.3万', trend: 'up', desc: '高能反转让人欲罢不能' },
  { tag: '甜宠剧场', heat: '76.8万', trend: 'hot', desc: '甜蜜剧情持续霸屏' },
  { tag: '韩剧新番', heat: '65.2万', trend: 'up', desc: '多部高分韩剧同步更新' },
  { tag: '现实主义', heat: '59.4万', trend: 'new', desc: '关注社会话题引发共鸣' },
  { tag: '仙侠玄幻', heat: '54.1万', trend: 'up', desc: '特效升级视觉盛宴' },
  { tag: '短剧崛起', heat: '48.7万', trend: 'hot', desc: '碎片时间追剧新选择' },
  { tag: '经典重温', heat: '42.3万', trend: 'up', desc: '老剧新看回味无穷' },
  { tag: '双男主', heat: '38.9万', trend: 'new', desc: '默契搭档引爆话题度' },
  { tag: '治愈温情', heat: '35.6万', trend: 'up', desc: '温暖故事抚慰心灵' },
  { tag: '泰剧热潮', heat: '31.2万', trend: 'new', desc: '东南亚风情强势来袭' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-600">全网剧迷都在讨论的追剧热点</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.tag}
              className="group bg-background-100 hover:bg-primary-50 rounded-full px-5 py-3 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer flex items-center gap-3 flex-wrap"
            >
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">#{topic.tag}</span>
              <span className="flex items-center gap-1 text-xs text-foreground-500">
                {topic.trend === 'hot' ? (
                  <i className="ri-fire-fill text-accent-500 text-xs"></i>
                ) : topic.trend === 'new' ? (
                  <i className="ri-sparkling-2-fill text-primary-500 text-xs"></i>
                ) : (
                  <i className="ri-arrow-up-fill text-primary-500 text-xs"></i>
                )}
                <span className="whitespace-nowrap">{topic.heat}</span>
              </span>
              <span className="hidden md:inline text-xs text-foreground-500">{topic.desc}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}